import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";


import "../App.css";
// eslint-disable-next-line
import DatePicker, { registerLocale } from "react-datepicker";
// eslint-disable-next-line
import ConfigETC from "../Class/ConfigETC.json";
import en from "date-fns/locale/en-US";


import CryptoJS from "crypto-js";

function padWithZeros(inputString) {
  // Check if the inputString's length is less than 8
  if (inputString.length < 8) {
    // Calculate the number of zeros needed to pad
    const zerosToAdd = 8 - inputString.length;
    
    // Create a string with the required number of zeros
    const zeroPadding = '0'.repeat(zerosToAdd);
    
    // Concatenate the zero padding with the inputString
    const paddedString = zeroPadding + inputString;
    
    return paddedString;
  } else {
    // If the inputString is already 8 characters or longer, return it as is
    return inputString;
  }
}





function ConvertTo64bit(textStr){
  // Your string
  let inputString = textStr;


  
  let keyBytes = padWithZeros(inputString);

  // console.log(keyBytes.toString(CryptoJS.enc.Hex));

  return keyBytes.toString(CryptoJS.enc.Hex);

  
}
// eslint-disable-next-line
function TestEncDec(textStr) {
  const plainText = textStr;
  const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF");
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");
  


  // เข้ารหัส
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  console.log("ข้อความที่เข้ารหัส:", encrypted);

  // ถอดรหัส
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  console.log("ข้อความที่ถอดรหัส:", decrypted);
}


// eslint-disable-next-line
function TestEncDecTripleDES(textStr) {
  const plainText = textStr;
  const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF");
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");
  


  // เข้ารหัส
  const encrypted = CryptoJS.TripleDES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  console.log("ข้อความที่เข้ารหัส Triple:", encrypted);

  // ถอดรหัส
  const decrypted = CryptoJS.TripleDES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  console.log("ข้อความที่ถอดรหัส Triple:", decrypted);
}



// eslint-disable-next-line
function TestEncTripleDES(textStr, saltkey) {
  const plainText = textStr;
  // const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF");
  const key = CryptoJS.enc.Utf8.parse(saltkey);
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");
  


  // เข้ารหัส
  const encrypted = CryptoJS.TripleDES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  
  return encrypted;
 
}

// eslint-disable-next-line
function TestDecTripleDES(textStr, saltkey) {
  const plainText = textStr;
  // const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF");
  const key = CryptoJS.enc.Utf8.parse(saltkey);
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");
  


 

  // ถอดรหัส
  const decrypted = CryptoJS.TripleDES.decrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  
  return decrypted;

}






// eslint-disable-next-line
function TestEnc(textStr, keyValue) {
  const plainText = textStr;
  // const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF" + salt);
  const key = CryptoJS.enc.Utf8.parse(keyValue);
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");

  const chunkSize = 1024; // Adjust the chunk size as needed
  const chunks = [];
  const encryptedChunks = [];

  const longText =  plainText;

  try {
    // เข้ารหัส
  for (let i = 0; i < longText.length; i += chunkSize) {
    chunks.push(longText.slice(i, i + chunkSize));

  }


  // Encrypt each chunk separately
  for (let i = 0; i < chunks.length; i++) {
    const encryptedChunk = CryptoJS.AES.encrypt(chunks[i], key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    encryptedChunks.push(encryptedChunk);
  }

  // const encrypted = CryptoJS.AES.encrypt(plainText, key, {
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // }).toString();
  //console.log("ข้อความที่เข้ารหัส:", encrypted);


  const encrypted = encryptedChunks.join('');

  return encrypted;
  } catch (error) {
    console.error('Encrypt error:', error);
    return 'Encrypt error:';
    // Handle the error gracefully
  }



  
}


function TestDec(encryptedText, keyValue) {
  const plainText = encryptedText;
  // const key = CryptoJS.enc.Utf8.parse("0123456789ABCDEF" + salt);
  const key = CryptoJS.enc.Utf8.parse(keyValue);
  const iv = CryptoJS.enc.Utf8.parse("1A2B3C4D5E6F7G8");
 
  try {
    const decrypted = CryptoJS.AES.decrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (error) {
    console.error('Decryption error:', error);
    // Handle the error gracefully
    return 'Decryption error:' + error.toString();
  }



  // เข้ารหัส
  
  
  //console.log("ข้อความที่เข้ารหัส:", textStr);





 
}
// eslint-disable-next-line
function TestMD5(textStr){
  // Your data to be hashed
  let dataToHash = 'Hello, World!';

  // Calculate the MD5 hash
  let md5Hash = CryptoJS.MD5(dataToHash);
  //console.log(md5Hash);


  // Convert the MD5 hash to a hexadecimal representation
  let md5Hex = md5Hash.toString(CryptoJS.enc.Hex);
  return md5Hex;
}




function M_holiday2() {


  //#region ###################  Declare a variable   ################### //#region
  registerLocale("en", en);
  // eslint-disable-next-line
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const loopElements = [];
  const loopElementsMD5 = [];
  const loopElementsTripleDES = [];



  // eslint-disable-next-line
  const [configData, setConfigData] = useState([]);
  //#endregion
  
  //#endregion

  //#region ###################  open on loead        ###################

  useEffect(() => {
    if (isFirst === true) {
      GetConfig();
 
      if (isLoadedConfigData === true) {
        setIsFirst(false);
        setIsLoadProgress(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedConfigData]);

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }


  //#endregion







  // for (let i = 0; i < 10; i++) {
  //   // เข้ารหัส
  //   let tempString = `Hello World: I love you!`;
  //   console.log(`ข้อความที่เข้ารหัส (${i + 1}):`);
  //   TestEncDec(tempString);
  //   //TestEncDecNoIV(tempString);
  // }


  for (let i = 0; i < 1; i++) {
    // Push elements into the array (or do something else with each iteration)
    let tempString = "สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ สวัสดีครับ ผมชื่อ Poom รูปหล่อ พ่อรวย แฟนสวยชื่อประธาน จุ๊กกรูๆๆๆๆๆๆๆๆๆ ";


    let utf8String = tempString;
;
    
    let key64bit = ConvertTo64bit("KAIZ");
    let key64bit2 = ConvertTo64bit("KAIZxx");



    let tempEncString = TestEnc(utf8String,key64bit);
    
    let tempDecString = TestDec(tempEncString,key64bit);

    let tempDecStringxx = TestDec(tempEncString,key64bit2);




    // let tempEncMD5String = TestMD5("12133333")

   
    

    // let tempEncTripleString = TestEncTripleDES(utf8String,key64bit);
    // let tempDecTripleString = TestDecTripleDES(tempEncTripleString,key64bit);
    // let tempDecTripleStringXXXX = TestDecTripleDES(tempEncTripleString,"0123456789ABCDEF");



   

    loopElements.push(<div key={i}>ข้อความที่เข้ารหัส {i + 1}: <font color="red">{utf8String}</font>  ::::: <font color="blue">{tempEncString}</font>  ::::: <font color="green">{tempDecString}</font> wrong::: {tempDecStringxx} </div>);

    // loopElementsMD5.push(<div key={i}>ข้อความที่เข้ารหัส {i + 1}: <font color="red">{utf8String}</font>  ::::: {tempEncMD5String}   </div>);
  
    // loopElementsTripleDES.push(<div key={i}>ข้อความที่เข้ารหัส {i + 1}: <font color="red">{utf8String}</font>  ::::: <font color="blue">{tempEncTripleString}</font>  ::::: <font color="green">{tempDecTripleString}</font> wrong::: {tempDecTripleStringXXXX} </div>);

    // loopElements.push(<div key={i}>ข้อความที่เข้ารหัส {i + 1}: <font color="red">{utf8String}</font>  ::::: <font color="blue">{tempEncString}</font>   ::::: <font color="green">{tempDecString}</font></div>);
  
  
  }

  //#endregion
  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <Helmet>
        <title>Holiday</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fa fa-suitcase" /> Holiday list{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                {/* <h5 className="display-5" /> */}
                <div className="card  shadow">
                  <div className="card-header ">
                    <h3 className="card-title">
                      Result <small> xxxxx items)</small>
                    </h3>
                  
                  </div>
                  {/* /.card-header */}
                  <div className="card-body table-responsive p-0">
                  {loopElements}
                  </div>
                </div>

                <div className="card  shadow">
                  <div className="card-header ">
                    <h3 className="card-title">
                      MD5 <small> xxxxx items)</small>
                    </h3>
                  
                  </div>
                  {/* /.card-header */}
                  <div className="card-body table-responsive p-0">
                  {loopElementsMD5}
                  </div>
                </div>

                <div className="card  shadow">
                  <div className="card-header ">
                    <h3 className="card-title">
                    TripleDES <small> xxxxx items)</small>
                    </h3>
                  
                  </div>
                  {/* /.card-header */}
                  <div className="card-body table-responsive p-0">
                  {loopElementsTripleDES}
                  </div>
                </div>
               
                {/* /.card */}
              </div>
            </div>
            {/* /.row (main row) */}


          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_holiday2;
